import {ReactNode} from 'react';
import {RowItem, Icon, Text} from './styled';

interface VerificationStepItemProps {
  icon: ReactNode;
  text?: string;
  isFixed?: boolean;
  className?: string;
}

const VerificationStepItem = ({icon, text, className}: VerificationStepItemProps) => {
  return (
    <RowItem className={className}>
      <Icon className="w-12 kiosko:w-[172px] kiosko:h-auto w-12">{icon}</Icon>
      <Text className="kiosko:text-kiosko-m">{text || ' '}</Text>
    </RowItem>
  );
};

export {VerificationStepItem};
